<template>
  <div class="watermark" ref="el">
    <canvas ref="canvasRef" class="watermark-bg" />
    <slot />
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from 'vue'
import { useWindowSize } from '@vueuse/core'
import watermark from '@/utils/watermark'
import type { IWatermarkOptions } from '@/utils/watermark'

const props = withDefaults(
  defineProps<
    Partial<Omit<IWatermarkOptions, 'text'>> & {
      text: string
    }
  >(),
  {
    family: 'SimSun',
  }
)
const el = ref<HTMLDivElement>()
const canvasRef = ref<HTMLCanvasElement>()
const { width, height } = useWindowSize()
let canvas: typeof canvasRef.value

function generate() {
  if (canvas && el.value) {
    watermark(canvas, {
      ...props,
      width: el.value.offsetWidth,
      height: el.value.offsetHeight,
    })
  }
}

watch([props, width, height], generate, { deep: true })
onMounted(() => {
  console.log('watermark-canvas mounted')
  canvas = canvasRef.value
  generate()
})
</script>

<style scoped lang="scss">
.watermark {
  position: relative;

  .watermark-bg {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
}
</style>
